// This file maps your class names (or icon names) to their font codes.
// You only need to update this one file when your font changes.
export const ICONS = {
    'logo': '\\e900',
    'arrow-right': '\\e901',
    'arrow-left': '\\e902',
    'truck-check': '\\e903',
    'truck': '\\e904',
    'bike': '\\e905',
    'd100': '\\e906',
    'phone': '\\e907',
    'facebook': '\\e908',
    'instagram': '\\e909',
    'twitter': '\\e90a',
    'youtube': '\\e90b',
    'left': '\\e90c',
    'right': '\\e90d',
    'down': '\\e90e',
    'up': '\\e90f',
    'info': '\\e910',
    'comment': '\\e911',
    'burger': '\\e912',
    'star': '\\e913',
    'star-full': '\\e914',
    'right-alt': '\\e915',
    'left-alt': '\\e916',
    'times': '\\e917',
    'times-alt': '\\e918',
    'times-alt-2': '\\e919',
    'check': '\\e91a',
    'check-alt': '\\e91b',
    'filter': '\\e91c',
    'search': '\\e91d',
    'like': '\\e91e',
    'like-alt': '\\e91f',
    'basket': '\\e920',
    'basket-alt': '\\e921',
    'basket-alt-2': '\\e922',
    'contact': '\\e923',
    'bin': '\\e924',
    'like-alt-2': '\\e925',
    'like-alt-3': '\\e926',
    'label-star': '\\e927',
    'delivery': '\\e928',
    'contact-alt-2': '\\e929',
    'contact-alt-3': '\\e92a',
    'sun': '\\e92b',
    'contact-alt-4': '\\e92c',
    'location': '\\e92d',
    'location-alt': '\\e92e',
    'truck-alt-3': '\\e92f',
    'logo-alt': '\\e930',
    'credit': '\\e931',
    'invoice': '\\e932',
    'receipt': '\\e933',
    'arrow-circle': '\\e934',
    'pen': '\\e935',
    'pen-alt': '\\e936',
    'frame': '\\e937',
    'info-alt': '\\e938',
    'fork': '\\e939',
    'mail': '\\e93a',
    'check-alt-2': '\\e93b',
    'size': '\\e93c',
    'play': '\\e93d',
    'zoom-in': '\\e93e',
    'zoom-out': '\\e93f',
    'arrow-up': '\\e940',
    'arrow-down': '\\e941',
    'jobrad': '\\e942',
    'minus-circle': '\\e943',
    'plus-circle': '\\e944',
    'calendar': '\\e945',
};

